import React from 'react';
import { ShieldIcon, KeyIcon, SmartphoneIcon, ActivityIcon } from 'lucide-react';
export const SecuritySettings = () => {
  return <div data-id="element-1536">
      <div className="mb-6" data-id="element-1537">
        <h2 className="text-lg font-semibold" data-id="element-1538">Security Settings</h2>
        <p className="text-gray-600" data-id="element-1539">
          Manage your account security and authentication methods
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1540">
        <div className="lg:col-span-2" data-id="element-1541">
          <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1542">
            <h3 className="text-lg font-medium mb-4" data-id="element-1543">Password</h3>
            <div className="space-y-4" data-id="element-1544">
              <div data-id="element-1545">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1546">
                  Current Password
                </label>
                <input type="password" className="w-full border border-gray-300 rounded-md px-3 py-2" placeholder="Enter current password" data-id="element-1547" />
              </div>
              <div data-id="element-1548">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1549">
                  New Password
                </label>
                <input type="password" className="w-full border border-gray-300 rounded-md px-3 py-2" placeholder="Enter new password" data-id="element-1550" />
              </div>
              <div data-id="element-1551">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1552">
                  Confirm New Password
                </label>
                <input type="password" className="w-full border border-gray-300 rounded-md px-3 py-2" placeholder="Confirm new password" data-id="element-1553" />
              </div>
            </div>
            <div className="mt-4 bg-yellow-50 p-3 rounded-md" data-id="element-1554">
              <p className="text-sm text-yellow-800" data-id="element-1555">
                <strong data-id="element-1556">Password requirements:</strong> Minimum 8 characters
                with at least one uppercase letter, one lowercase letter, one
                number, and one special character.
              </p>
            </div>
            <div className="mt-6 flex justify-end" data-id="element-1557">
              <button className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors" data-id="element-1558">
                Update Password
              </button>
            </div>
          </div>
          <div className="mt-6 bg-white border border-gray-200 rounded-lg p-6" data-id="element-1559">
            <h3 className="text-lg font-medium mb-4" data-id="element-1560">
              Two-Factor Authentication
            </h3>
            <div className="flex items-center justify-between mb-6" data-id="element-1561">
              <div data-id="element-1562">
                <p className="font-medium" data-id="element-1563">Two-Factor Authentication</p>
                <p className="text-sm text-gray-500" data-id="element-1564">
                  Add an extra layer of security to your account
                </p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer" data-id="element-1565">
                <input type="checkbox" className="sr-only peer" data-id="element-1566" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600" data-id="element-1567"></div>
              </label>
            </div>
            <div className="space-y-4" data-id="element-1568">
              <div className="flex items-center p-4 border border-gray-200 rounded-lg" data-id="element-1569">
                <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center mr-4" data-id="element-1570">
                  <SmartphoneIcon size={20} className="text-indigo-600" data-id="element-1571" />
                </div>
                <div data-id="element-1572">
                  <p className="font-medium" data-id="element-1573">Authenticator App</p>
                  <p className="text-sm text-gray-500" data-id="element-1574">
                    Use an authenticator app to generate verification codes
                  </p>
                </div>
                <button className="ml-auto text-sm text-indigo-600 hover:text-indigo-800" data-id="element-1575">
                  Setup
                </button>
              </div>
              <div className="flex items-center p-4 border border-gray-200 rounded-lg" data-id="element-1576">
                <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center mr-4" data-id="element-1577">
                  <SmartphoneIcon size={20} className="text-indigo-600" data-id="element-1578" />
                </div>
                <div data-id="element-1579">
                  <p className="font-medium" data-id="element-1580">SMS Authentication</p>
                  <p className="text-sm text-gray-500" data-id="element-1581">
                    Receive verification codes via SMS
                  </p>
                </div>
                <button className="ml-auto text-sm text-indigo-600 hover:text-indigo-800" data-id="element-1582">
                  Setup
                </button>
              </div>
            </div>
          </div>
        </div>
        <div data-id="element-1583">
          <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1584">
            <h3 className="text-lg font-medium mb-4" data-id="element-1585">Security Status</h3>
            <div className="mb-6" data-id="element-1586">
              <div className="flex items-center justify-between mb-2" data-id="element-1587">
                <span className="text-sm font-medium" data-id="element-1588">Overall Security</span>
                <span className="text-sm text-yellow-600" data-id="element-1589">Medium</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1590">
                <div className="bg-yellow-500 h-2 rounded-full" style={{
                width: '60%'
              }} data-id="element-1591"></div>
              </div>
            </div>
            <div className="space-y-4" data-id="element-1592">
              <div className="flex items-center" data-id="element-1593">
                <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-1594">
                  <ShieldIcon size={16} className="text-green-600" data-id="element-1595" />
                </div>
                <div data-id="element-1596">
                  <p className="font-medium" data-id="element-1597">Strong Password</p>
                  <p className="text-xs text-gray-500" data-id="element-1598">
                    Last changed 30 days ago
                  </p>
                </div>
              </div>
              <div className="flex items-center" data-id="element-1599">
                <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-1600">
                  <KeyIcon size={16} className="text-red-600" data-id="element-1601" />
                </div>
                <div data-id="element-1602">
                  <p className="font-medium" data-id="element-1603">Two-Factor Authentication</p>
                  <p className="text-xs text-gray-500" data-id="element-1604">Not enabled</p>
                </div>
              </div>
              <div className="flex items-center" data-id="element-1605">
                <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-1606">
                  <ActivityIcon size={16} className="text-green-600" data-id="element-1607" />
                </div>
                <div data-id="element-1608">
                  <p className="font-medium" data-id="element-1609">Recent Activity</p>
                  <p className="text-xs text-gray-500" data-id="element-1610">
                    No suspicious activity
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 bg-white border border-gray-200 rounded-lg p-6" data-id="element-1611">
            <h3 className="text-lg font-medium mb-4" data-id="element-1612">Login Sessions</h3>
            <div className="space-y-4" data-id="element-1613">
              <div className="p-3 border border-green-200 bg-green-50 rounded-lg" data-id="element-1614">
                <div className="flex justify-between items-center" data-id="element-1615">
                  <div data-id="element-1616">
                    <p className="font-medium text-green-800" data-id="element-1617">
                      Current Session
                    </p>
                    <p className="text-xs text-green-700" data-id="element-1618">Chrome on Windows</p>
                  </div>
                  <span className="text-xs bg-green-200 text-green-800 px-2 py-1 rounded-full" data-id="element-1619">
                    Active
                  </span>
                </div>
                <p className="text-xs text-green-700 mt-1" data-id="element-1620">
                  IP: 192.168.1.1 • Started: Today, 9:45 AM
                </p>
              </div>
              <div className="p-3 border border-gray-200 rounded-lg" data-id="element-1621">
                <div className="flex justify-between items-center" data-id="element-1622">
                  <div data-id="element-1623">
                    <p className="font-medium" data-id="element-1624">Safari on macOS</p>
                    <p className="text-xs text-gray-500" data-id="element-1625">
                      Last active: Yesterday
                    </p>
                  </div>
                  <button className="text-xs text-red-600 hover:text-red-800" data-id="element-1626">
                    Logout
                  </button>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-1627">
                  IP: 192.168.1.2 • Started: Yesterday, 3:20 PM
                </p>
              </div>
              <div className="p-3 border border-gray-200 rounded-lg" data-id="element-1628">
                <div className="flex justify-between items-center" data-id="element-1629">
                  <div data-id="element-1630">
                    <p className="font-medium" data-id="element-1631">Mobile App on iPhone</p>
                    <p className="text-xs text-gray-500" data-id="element-1632">
                      Last active: 3 days ago
                    </p>
                  </div>
                  <button className="text-xs text-red-600 hover:text-red-800" data-id="element-1633">
                    Logout
                  </button>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-1634">
                  IP: 192.168.1.3 • Started: 3 days ago, 10:15 AM
                </p>
              </div>
            </div>
            <div className="mt-4 flex justify-end" data-id="element-1635">
              <button className="text-sm text-red-600 hover:text-red-800" data-id="element-1636">
                Logout of all other sessions
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};